module.exports = __webpack_public_path__ + "img/mainMenu-iconStore.a13af718.svg";